import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('highlight', {
    beforeMount(el, binding) {
      const highlightText = () => {
        const searchTerm = binding.value;
        console.log(searchTerm)
        const regex = new RegExp(`(${searchTerm})`, 'gi');

        el.innerHTML = el.__originalContent || el.innerHTML;

        if (!el.__originalContent) el.__originalContent = el.innerHTML;

        if (searchTerm) {
          el.innerHTML = el.innerHTML.replace(regex, '<span class="highlighted">$1</span>');
        }
      };

      highlightText();

      el.__highlightText = highlightText;
    },
    updated(el) {
      el.__highlightText();
    },
    unmounted(el) {
      delete el.__originalContent;
      delete el.__highlightText;
    }
  });
});
